(() => {
  document.querySelectorAll('[data-tc-restock]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const product = JSON.parse(root.dataset.product);
    const status = root.querySelector('[data-restock-status]');
    root.querySelectorAll('[data-restock-variant]').forEach(button => {
      button.addEventListener('click', async () => {
        status.hidden = true;
        if (!window.location.pathname.startsWith('/products/')) {
          const destination = new URL(root.dataset.productUrl, window.location.origin);
          destination.searchParams.set('restock', button.dataset.restockVariant);
          destination.hash = 'tc-restock';
          window.location.assign(destination);
          return;
        }
        button.disabled = true;
        try {
          for (let attempt = 0; attempt < 40; attempt++) {
            if (typeof window._RestockRocket?.openModal === 'function') {
              window._RestockRocket.openModal(product, button.dataset.restockVariant);
              return;
            }
            await new Promise(resolve => setTimeout(resolve, 250));
          }
          status.textContent = '通知フォームを読み込めませんでした。ページを更新して、もう一度お試しください。';
          status.hidden = false;
        } finally { button.disabled = false; }
      });
    });
    const requestedVariant = new URLSearchParams(window.location.search).get('restock');
    const requestedButton = Array.from(root.querySelectorAll('[data-restock-variant]')).find(button => button.dataset.restockVariant === requestedVariant);
    if (requestedButton) requestedButton.click();
  });
})();
